<template>
  <div class="card">
    <div class="pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t('listeContratReconductible.popUpReconduction.title') }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <error-msg-component :messages="messages"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :error="error"
                             :title="'addEditCivilite.error.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
        <app-information-msg-component
          title="listeContratReconductible.popUpReconduction.information"
                                       :libelleList="[{ islink: false,
          libelle: $t('listeContratReconductible.popUpReconduction.infoEcheance')}]"
                                       :canClose="false">
        </app-information-msg-component>
        <div class="columns mgt-20px">
          <div class="column is-narrow">
            <b-field :label="$t('listeContratReconductible.popUpReconduction.reconduireSur')"
                     class="obligatoire">
              <b-input v-model="reconduction.nMoisReconduction"></b-input>
            </b-field>
          </div>
          <div class="column is-narrow is-flex align-items-flex-end">
            <b-select expanded v-model="periodiciteReconduction">
              <option v-for="(periodicite) in periodiciteUnite"
                      :key="periodicite.code"
                      :value="periodicite.code">
                {{ $t(periodicite.libelle) }}
              </option>
            </b-select>
          </div>
          <div class="column is-narrow">
            <b-field :label="$t('listeContratReconductible.popUpReconduction.termePaiement')">
              <b-select  v-model="reconduction.termePaiement" expanded>
                <option :value="null">
                  {{ $t('listeContratReconductible.popUpReconduction.multiTermePaiementContrat') }}
                </option>
                <option v-for="termePaiement in listTermePaiement"
                        :key="termePaiement.code"
                        :value="termePaiement.code">
                  {{ $t(termePaiement.libelle) }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-narrow">
            <b-field :label="$t('listeContratReconductible.popUpReconduction.modePaiement')">
              <b-select expanded v-model="reconduction.modeReglementId">
                <option :value="null">
                  {{ $t('listeContratReconductible.popUpReconduction.multiModePaiementBailleur') }}
                </option>
                <option v-for="modeReglement in modesReglement"
                        :key="modeReglement.id"
                        :value="modeReglement.id">
                  {{modeReglement.libelle}}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <footer class="mgt-20px">
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('listeContratReconductible.popUpReconduction.actions.cancel')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="reconductionContrat">
                {{ $t('listeContratReconductible.popUpReconduction.actions.reconduire')}}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import genererReconductionContrat from '@/services/baux/contrat/reconductible/genererReconductionContrat';
import {
  LISTE_TERME_PAIEMENT, MOIS, ANNEE, PERIODICITE_UNITE,
} from '@/configuration/baux/contrat/contratConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { AUCUN } from '@/configuration/parametrage/modeReglementConf';
import messageErreur from '@/services/general/messageErreur';
import { reconductionContrat } from '@/api/baux/contrat';
import formatIsoDate from '@/services/general/formatIsoDate';
import messageSucces from '@/services/general/messageSucces';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validation from '@/services/validation/validation';
import validationReconductionContrat from '@/services/baux/contrat/reconductible/validationReconductionContrat';
import translate from '@/services/baux/contrat/reconductible/translatorReconduction';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'p_reconductionContrat',
  props: {
    contratsAReconduire: {
      type: Array,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
    AppInformationMsgComponent,
  },
  data() {
    return {
      reconduction: genererReconductionContrat(),
      periodiciteUnite: PERIODICITE_UNITE,
      listTermePaiement: LISTE_TERME_PAIEMENT,
      periodiciteReconduction: ANNEE,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
    };
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    async reconductionContrat() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const listesContrat = [];
        this.contratsAReconduire.forEach((contrat) => {
          const contratAReconduire = cloneDeep(this.reconduction);
          if (this.periodiciteReconduction !== MOIS) contratAReconduire.nMoisReconduction *= 12;
          contratAReconduire.contratId = contrat.id;
          contratAReconduire.dateDebutReconduction = formatIsoDate(moment(contrat.dateFinEcheance).add(1, 'day'));
          contratAReconduire.montantAnnuelHt = contrat.loyerAnnuelHt;
          listesContrat.push(contratAReconduire);
        });
        await reconductionContrat(listesContrat);
        loadingComponent.close();
        messageSucces(this.$t('listeContratReconductible.popUpReconduction.success.contratReconduit'));
        this.$emit('closeAndRefresh');
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          this.messages = [];
          this.messagesChampsVide = [];
          this.champsVide = [];
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validationReconductionContrat(e.response, this.messages);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    modesReglement() {
      const modesReglement = this.parametre(PARAMETRES_KEYS.modeReglement);
      return modesReglement.filter((modeReglement) => {
        return modeReglement.actionAchat !== AUCUN;
      });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.modeReglement]);
      if (this.contratsAReconduire.length === 1) {
        this.reconduction.montantAnnuelHt = this.contratsAReconduire[0].loyerAnnuelHt;
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
